import React from 'react';

const OrgLayout = ({ children }) => {
  return children;
};

export default OrgLayout;
